import { Button, Dropdown, Icon } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import CompanySelector from '../../CompanySelector';
import useOption from 'components/customHooks';
import PopupContext from 'contexts/PopupContext';
const PartyEditor = ({ value, onChange, remove }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [companyId, setCompanyId] = React.useState(value?.companyId);
    const [type, setType] = React.useState(value?.type);
    const typeOptions = useOption('/syndicate/meta/transaction-role/options');
    const disabled = false;
    const onChangeCompany = React.useCallback((newCompanyId) => {
        setCompanyId(newCompanyId);
        const newParty = newCompanyId !== undefined && type !== undefined ? { companyId: newCompanyId, type } : undefined;
        onChange({ target: { value: newParty } });
    }, [onChange, type]);
    const onChangeType = React.useCallback((event) => {
        const newType = event.target.value.value;
        setType(newType);
        const newParty = companyId !== undefined ? { companyId, type: newType } : undefined;
        onChange({ target: { value: newParty } });
    }, [companyId, onChange]);
    const onClickDelete = React.useCallback(() => {
        remove();
    }, [remove]);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement("div", { style: { marginRight: '0.5rem', width: '8rem' } },
            React.createElement(Dropdown, { label: "Type", onChange: onChangeType, onMenuClose: () => setBlockClose(false), onMenuOpen: () => setBlockClose(true), options: typeOptions, value: typeOptions.find(o => 'value' in o && o.value === type) })),
        React.createElement(CompanySelector, { companyId: companyId, disabled: disabled, label: "Company", onChange: onChangeCompany, style: { marginRight: '0.5rem', width: '20rem' } }),
        React.createElement("div", { style: { alignSelf: 'end' } },
            React.createElement(Button, { iconButton: true, onClick: onClickDelete, size: 'small' },
                React.createElement(Icon, { iconName: 'delete' })))));
};
export default PartyEditor;
